import { DeepPartial, RelatedTagsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_RELATED_TAGS_CONFIG: DeepPartial<RelatedTagsConfig> = {
  components: {
    rightIcon: 'GoccoChevronIcon',
    leftIcon: 'GoccoChevronIcon'
  },
  selectable: true,
  relatedTags: {
    showSelectedValues: true
  }
};
